/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select';

import axios from 'axios';
import { addTemplateFolder } from '@/actions/templateFolders';
import getWebchatApiUrl from '../../utils/getWebchatUrl';
import CustomDragAndDropUploader from './CustomDragAndDropUploader';
import { Input } from '@/components/ui/input';
import { Textarea } from '../ui/textarea';

import { Button } from '@/components/ui/button';

import { Dialog, DialogContent } from '@/components/ui/dialog';

import { IconButton } from '../ui/custom/IconButton';

import { AlertCircleIcon } from 'lucide-react';

const style = { previewText: { whiteSpace: 'pre-wrap' } };

// set constants
const INVITATION_TAG = '((review_invitation))';
const LINK_TAG = '((review_link))';
const IMAGE_TAG = '((image))';
const NAME_TAG_RE = /\(\(name\)\)/g;
const FIRST_NAME_TAG_RE = /\(\(first_name\)\)/g;
const EMPLOYEE_NAME_TAG_RE = /\(\(me\)\)/g;
const BUSINESS_TAG_RE = /\(\(business\)\)/g;
const EMPLOYEE_FULL_TAG_RE = /\(\(full_me\)\)/g;
const FULL_NAME_RE = /\(\(full_name\)\)/g;
const FIRST_NAME_TAG = '((first_name))';
const EMPLOYEE_NAME_TAG = '((me))';
const BUSINESS_TAG = '((business))';
const EMPLOYEE_FULL_NAME_TAG = '((full_me))';
const FULL_NAME_TAG = '((full_name))';

const languages = {
	en: 'English',
	fr: 'French',
	es: 'Spanish',
};

class CreateTemplateDialog extends Component {
	constructor(props) {
		super(props);

		this.messageInput = React.createRef();

		this.INIT_STATE = {
			text: '',
			title: '',
			isReviewInvitation: false,
			isReviewLink: false,
			isFavorite: false,
			isAutomated: false,
			isGroupChat: !!this.props.defaultIsGroupChat,
			_folder: this.props.defaultFolderId || null,
			mediaUrl: '',
			templateImageUrl: '',
			formData: null,
			language: '',
			loading: false,
			newFolderMode: false,
			newFolderTitle: '',
			folderError: '',
		};

		this.EDIT_STATE = this.props.selectedTemplate
			? {
					text: this.props.selectedTemplate.text,
					title: this.props.selectedTemplate.title,
					isReviewInvitation:
						this.props.selectedTemplate.type ===
							'review-invitation' ||
						this.props.selectedTemplate.type ===
							'default-review-invitation',
					isReviewLink:
						this.props.selectedTemplate.type === 'review-link' ||
						this.props.selectedTemplate.text.includes(LINK_TAG),

					isFavorite: this.props.selectedTemplate.isFavorite,
					isAutomated:
						this.props.selectedTemplate.type ===
						'default-review-invitation',
					isGroupChat: !!this.props.selectedTemplate.isGroupChat,
					_folder: this.props.selectedTemplate._folder
						? String(this.props.selectedTemplate._folder)
						: null,
					mediaUrl: '',
					templateImageUrl: '',
					formData: null,
					language:
						languages[this.props.selectedTemplate.language || 'en'],
					loading: false,
					newFolderMode: false,
					newFolderTitle: '',
					folderError: '',
				}
			: null;

		this.state = this.EDIT_STATE || this.INIT_STATE;

		this.webchatApiUrl = getWebchatApiUrl(window.location.href);
	}

	async componentDidMount() {
		this.setReviewInvitationImage();
		this.setTemplateImage();
	}

	formatMessageForPreview = ({ message }) => {
		if (!message) {
			return '';
		}

		const { auth } = this.props;

		const employeeFullName = auth.user.name || '';

		const formattedName = employeeFullName
			.toLowerCase()
			.split(' ')
			.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
			.join(' ');

		const employeeFirstName = formattedName.split(' ')[0];

		let formattedMessage = '';

		formattedMessage = message.replace(
			EMPLOYEE_NAME_TAG_RE,
			employeeFirstName,
		);

		formattedMessage = formattedMessage.replace(NAME_TAG_RE, 'Jane');

		formattedMessage = formattedMessage.replace(FIRST_NAME_TAG_RE, 'Jane');

		formattedMessage = formattedMessage.replace(
			EMPLOYEE_FULL_TAG_RE,
			employeeFullName,
		);

		formattedMessage = formattedMessage.replace(FULL_NAME_RE, 'Jane Doe');

		formattedMessage = formattedMessage.replace(
			BUSINESS_TAG_RE,
			this.props.auth.name,
		);

		formattedMessage = formattedMessage.replace(
			LINK_TAG,
			this.props.auth.reseller ? 'www.reviw.me' : 'share.chekkit.io',
		);

		formattedMessage = formattedMessage.replace(
			INVITATION_TAG,
			this.props.auth.reseller ? 'www.reviw.me' : 'share.chekkit.io',
		);

		formattedMessage = formattedMessage.replace(IMAGE_TAG, '');

		return formattedMessage;
	};

	setReviewInvitationImage = async () => {
		try {
			const res = await axios.get('/api/media-url');
			const { mediaUrl } = res.data;

			if (mediaUrl) {
				this.setState({ mediaUrl });
			}
		} catch (err) {
			console.log('error checking if rr image exists ', err);
		}
	};

	setTemplateImage = async () => {
		try {
			const { selectedTemplate } = this.props;

			if (selectedTemplate && selectedTemplate.text.includes(IMAGE_TAG)) {
				const res = await axios.post('/api/template-image-url', {
					_template: selectedTemplate._id,
				});

				const { templateImageUrl } = res.data;

				if (templateImageUrl) {
					this.setState({ templateImageUrl });
				}
			}
		} catch (err) {
			console.log('error checking if rr image exists ', err);
		}
	};

	updateTemplateTitle = (event) => {
		this.setState({ title: event.target.value });
	};

	updateTemplateText = (event) => {
		if (event.target.value.length > 1599) {
			return this.setState({ text: event.target.value.slice(0, 1599) });
		}

		// turn toggle on and off automatically if text includes the associated tag
		const isReviewInvitation = event.target.value.includes(INVITATION_TAG);
		const isReviewLink = event.target.value.includes(LINK_TAG);

		this.setState({
			text: event.target.value,
			isReviewInvitation,
			isReviewLink,
		});
	};

	updateIsReviewLink = () => {
		const { text, isReviewLink } = this.state;

		const nextReviewLinkState = !isReviewLink;
		// if the next state includes a review invitation add ((review_link)) to the message body
		if (nextReviewLinkState) {
			const textWithReviewLinkTag = `${text} ((review_link))`;
			this.setState({ text: textWithReviewLinkTag });
		} else {
			// otherwise remove ((review_link)) from the message body
			const textWithoutReviewLinkTag = text
				.replace('((review_link))', '')
				.trim();
			this.setState({ text: textWithoutReviewLinkTag });
		}

		this.setState({
			isReviewLink: nextReviewLinkState,
		});
	};

	updateIsReviewInvitation = () => {
		const { text, isReviewInvitation } = this.state;

		const nextReviewInvitationState = !isReviewInvitation;
		// if the next state includes a review invitation add ((review_invitation)) to the message body
		if (nextReviewInvitationState) {
			const textWithReviewInvitationTag = `${text} ((review_invitation))`;
			this.setState({ text: textWithReviewInvitationTag });
		} else {
			// otherwise remove ((review_invitation)) from the message body
			const textWithoutReviewInvitationTag = text
				.replace('((review_invitation))', '')
				.trim();
			this.setState({ text: textWithoutReviewInvitationTag });
		}

		this.setState({
			isReviewInvitation: nextReviewInvitationState,
		});
	};

	updateIsFavorite = () => {
		this.setState({ isFavorite: !this.state.isFavorite });
	};

	updateIsAutomated = () => {
		this.setState({ isAutomated: !this.state.isAutomated });
	};

	updateIsGroupChat = () => {
		const nextIsGroupChat = !this.state.isGroupChat;

		if (!nextIsGroupChat) {
			return this.setState({ isGroupChat: false });
		}

		// group chat messages go to teammates through the teams service, which
		// resolves no merge tags and attaches no images — strip anything the
		// hidden controls would otherwise leave behind in the text, collapsing
		// only the whitespace adjacent to each removed tag (never the user's
		// own spacing elsewhere)
		const text = this.state.text
			.replace(
				/[^\S\n]*\(\((?:review_invitation|review_link|image)\)\)[^\S\n]*/g,
				' ',
			)
			.replace(/^[^\S\n]+|[^\S\n]+$/gm, '')
			.trim();

		this.setState({
			isGroupChat: true,
			text,
			isReviewInvitation: false,
			isReviewLink: false,
			isAutomated: false,
			formData: null,
			templateImageUrl: '',
		});
	};

	handleFolderSelectChange = (value) => {
		if (value === '__new__') {
			return this.setState({
				newFolderMode: true,
				newFolderTitle: '',
				folderError: '',
			});
		}

		this.setState({
			_folder: value === '__unfiled__' ? null : value,
			newFolderMode: false,
			folderError: '',
		});
	};

	createFolderInline = async () => {
		const title = this.state.newFolderTitle.trim();

		if (!title) {
			return this.setState({ folderError: 'Please enter a folder name' });
		}

		const duplicate = (this.props.templateFolders || []).find(
			(folder) => folder.title.toLowerCase() === title.toLowerCase(),
		);
		if (duplicate) {
			return this.setState({
				folderError: `A folder named "${title}" already exists`,
			});
		}

		const result = await this.props.addTemplateFolder({ title });

		if (result?.error || !result?.folder?._id) {
			return this.setState({
				folderError: result?.message || 'Could not create the folder',
			});
		}

		this.setState({
			_folder: String(result.folder._id),
			newFolderMode: false,
			newFolderTitle: '',
			folderError: '',
		});
	};

	submitTemplate = async () => {
		try {
			const {
				text,
				title,
				isReviewInvitation,
				isReviewLink,
				isFavorite,
				isAutomated,
				isGroupChat,
				_folder,
				formData,
				language,
			} = this.state;

			this.setState({ loading: true });

			// post to create route
			const res = await axios(`/api/template/create`, {
				method: 'post',
				data: {
					text,
					title,
					isReviewInvitation: isGroupChat ? false : isReviewInvitation,
					isReviewLink: isGroupChat ? false : isReviewLink,
					isFavorite,
					isAutomated: isGroupChat ? false : isAutomated,
					language,
					isGroupChat,
					_folder,
				},
				withCredentials: true,
			});

			if (formData) {
				const { template } = res.data;

				formData.set('_template', template._id);

				await axios.post(`/api/upload-template-image`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				});
			}

			if (res.data.error) {
				const { message } = res.data;
				return alert(
					message ||
						'There was an error creating your template. Please try again.',
				);
			}

			this.props.getUserTemplates();
			this.closeDialog();
		} catch (err) {
			console.log(err);
		} finally {
			this.setState(this.INIT_STATE);
		}
	};

	editTemplate = async () => {
		try {
			const {
				text,
				title,
				isReviewInvitation,
				isReviewLink,
				isFavorite,
				isAutomated,
				isGroupChat,
				_folder,
				formData,
				language,
			} = this.state;

			this.setState({ loading: true });

			const { selectedTemplate } = this.props;
			// post to edit route
			const res = await axios(`/api/template/update`, {
				method: 'post',
				data: {
					template: selectedTemplate,
					text,
					title,
					isReviewInvitation: isGroupChat ? false : isReviewInvitation,
					isReviewLink: isGroupChat ? false : isReviewLink,
					isFavorite,
					isAutomated: isGroupChat ? false : isAutomated,
					language,
					isGroupChat,
					_folder,
				},
				withCredentials: true,
			});

			if (res.data.error) {
				const { message } = res.data;
				return alert(
					message ||
						'There was an error creating your template. Please try again.',
				);
			}

			if (formData) {
				formData.set('_template', selectedTemplate._id);

				await axios.post(`/api/upload-template-image`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				});
			}

			this.props.getUserTemplates();

			this.closeDialog();
		} catch (err) {
			console.log(err);
		} finally {
			this.setState(this.INIT_STATE);
		}
	};

	getTitle = () => this.state.title;

	getText = () => this.state.text;

	getReviewInvitationCheckboxValue = () => this.state.isReviewInvitation;

	getReviewLinkCheckboxValue = () => this.state.isReviewLink;

	getFavoriteCheckboxValue = () => this.state.isFavorite;

	getAutomatedCheckboxValue = () => this.state.isAutomated;

	addTagToText = (tag) => {
		const { text } = this.state;
		const messageCursorPosition = this.messageInput.current.selectionStart;

		if (text) {
			const textBeforeCursorPosition = text.substring(
				0,
				messageCursorPosition,
			);
			const textAfterCursorPosition = text.substring(
				messageCursorPosition,
				text.length,
			);
			const updatedText = `${textBeforeCursorPosition}${tag}${textAfterCursorPosition}`;

			this.setState({ text: updatedText }, () =>
				this.messageInput.current.setSelectionRange(
					messageCursorPosition + tag.length,
					messageCursorPosition + tag.length,
				),
			);

			this.messageInput.current.focus();

			return;
		}

		this.setState({ text: `${tag}` });
		this.messageInput.current.focus();
	};

	addFullNameTagToText = () => {
		const { text } = this.state;

		if (text) {
			return this.setState({
				text: `${this.state.text.trim()} ((full_name))`,
			});
		}
		return this.setState({ text: `((full_name))` });
	};

	addEmployeeNameTagToText = () => {
		const { text } = this.state;

		if (text) {
			return this.setState({
				text: `${this.state.text.trim()} ((me))`,
			});
		}
		return this.setState({ text: `((me))` });
	};

	addEmployeeFullNameTagToText = () => {
		const { text } = this.state;

		if (text) {
			return this.setState({
				text: `${this.state.text.trim()} ((full_me))`,
			});
		}
		return this.setState({ text: `((full_me))` });
	};

	addBusinessNameTagToText = () => {
		const { text } = this.state;

		if (text) {
			return this.setState({
				text: `${this.state.text.trim()} ((business))`,
			});
		}
		return this.setState({ text: `((business))` });
	};

	closeDialog = () => {
		this.setState(this.INIT_STATE);
		this.props.handleCloseCreateTemplateDialog();
	};

	buttonEnabled = () => {
		const { text, title, loading } = this.state;

		if (loading) {
			return false;
		}

		if (!text) {
			return false;
		}

		if (!title) {
			return false;
		}

		return true;
	};

	// handle form when image is dropped onto CustomDragAndDropUploader
	handleForm = (formData) => {
		const file = formData.get('file');

		const { preview } = file;

		const { text } = this.state;

		let textWithImageTag = text;

		// update text to have ((image)) tag only if it is not already there
		// i.e. user has not uploaded an image yet
		if (!text.includes(IMAGE_TAG)) {
			textWithImageTag = `${text} ${IMAGE_TAG}`;
		}

		// save text, file and preview
		this.setState({
			text: textWithImageTag,
			formData,
			templateImageUrl: preview,
		});
	};

	handleLanguageChange = (language) => {
		this.setState({ language });
	};

	resetTemplateImageUrl = () => {
		this.setState({
			templateImageUrl: '',
			text: this.state.text.replace(` ${IMAGE_TAG}`, ''),
			formData: null,
		});
	};

	renderMessagePreview = (message) => {
		if (!message) {
			return <div />;
		}

		// group chat messages are delivered exactly as written — the teams
		// service resolves no merge tags, so preview the raw text and warn
		// about any ((tag)) the user typed manually
		if (this.state.isGroupChat) {
			return (
				<div className="space-y-3">
					<p style={style.previewText}>{message}</p>
					{/\(\(.+?\)\)/.test(message) && (
						<p className="text-xs text-amber-600 dark:text-amber-500">
							Merge tags are not replaced in group chat messages —
							this will send exactly as written.
						</p>
					)}
				</div>
			);
		}

		const formattedMessage = this.formatMessageForPreview({ message });

		// render preview if user is using the custom image
		if (message.includes(IMAGE_TAG) || this.state.formData) {
			if (!this.state.templateImageUrl) {
				return <p style={style.previewText}>{formattedMessage}</p>;
			}

			return (
				<div>
					<img
						className="w-[180px]"
						src={this.state.templateImageUrl}
						alt="review-invite"
					/>
					<p style={style.previewText}>{formattedMessage}</p>
				</div>
			);
		}

		// render preview if they have a review invitation image
		if (message.includes(INVITATION_TAG)) {
			if (!this.state.mediaUrl) {
				return <p style={style.previewText}>{formattedMessage}</p>;
			}

			return (
				<div>
					<img
						className="w-[180px]"
						src={this.state.mediaUrl}
						alt="review-invite"
					/>
					<p style={style.previewText}>{formattedMessage}</p>
				</div>
			);
		}

		return <p style={style.previewText}>{formattedMessage}</p>;
	};

	render() {
		return (
			<Dialog
				open={this.props.open}
				className="sm:max-w-[1200px]"
				onOpenChange={(open) => {
					if (!open) this.closeDialog();
				}}
			>
				<DialogContent
					mobileVariant="fullscreen"
					className="sm:max-w-[1200px] max-h-[90dvh] flex flex-col p-0 gap-0 max-md:overflow-hidden"
				>
					<div className="flex flex-col min-h-0 overflow-hidden max-md:flex-1">
						<div className="p-6 border-b shrink-0 max-md:py-3.5 max-md:pl-4 max-md:pr-14">
							<h2 className="text-xl font-semibold max-md:text-[17px]">
								{this.EDIT_STATE ? 'Update' : 'Create'} Template
							</h2>
						</div>

						<div className="grid grid-cols-1 md:grid-cols-3 grow min-h-0 overflow-y-auto md:overflow-hidden max-md:overscroll-contain">
							{/* Form section */}
							<div className="md:col-span-2 p-6 md:overflow-y-auto md:max-h-[70vh] md:border-r max-md:p-4">
								<div className="space-y-6">
									{/* Title field */}
									<div className="space-y-2">
										<Label
											htmlFor="title"
											className="text-sm font-medium"
										>
											Template Title
										</Label>
										<Input
											id="title"
											value={this.getTitle()}
											onChange={this.updateTemplateTitle}
											placeholder="Enter a descriptive title"
											className="w-full"
											autoComplete="off"
											enterKeyHint="next"
										/>
									</div>

									{/* Message field */}
									<div className="space-y-2">
										<div className="flex items-center justify-between">
											<Label
												htmlFor="message"
												className="text-sm font-medium"
											>
												Message Content
											</Label>
											<span className="text-xs text-muted-foreground">
												{this.state.text.length} / 1600
											</span>
										</div>
										<Textarea
											id="message"
											value={this.getText()}
											onChange={this.updateTemplateText}
											placeholder="Type your message here..."
											className="min-h-[150px] w-full max-md:min-h-[180px]"
											ref={this.messageInput}
										/>
									</div>

									{/* Group chat template toggle */}
									<div className="space-y-1">
										<div className="flex items-center space-x-2 max-md:min-h-11">
											<Switch
												checked={this.state.isGroupChat}
												onCheckedChange={
													this.updateIsGroupChat
												}
												id="is-group-chat"
											/>
											<Label
												htmlFor="is-group-chat"
												className="text-sm"
											>
												Group Chat template
											</Label>
										</div>
										<p className="text-xs text-muted-foreground pl-11">
											For internal team group chats — sent
											to teammates, not customers.
										</p>
									</div>

									{/* Quick tags */}
									{!this.state.isGroupChat && (
									<div className="space-y-2">
										<Label className="text-sm font-medium">
											Quick Tags
										</Label>
										<div className="flex flex-wrap gap-2 max-md:[&>button]:h-11">
											<Button
												onClick={() =>
													this.addTagToText(
														FIRST_NAME_TAG,
													)
												}
												variant="outline"
												size="sm"
											>
												Customer Name
											</Button>
											<Button
												onClick={() =>
													this.addTagToText(
														EMPLOYEE_NAME_TAG,
													)
												}
												variant="outline"
												size="sm"
											>
												Employee Name
											</Button>
											<Button
												onClick={() =>
													this.addTagToText(
														BUSINESS_TAG,
													)
												}
												variant="outline"
												size="sm"
											>
												Business Name
											</Button>
											<Button
												onClick={() =>
													this.addTagToText(
														FULL_NAME_TAG,
													)
												}
												variant="outline"
												size="sm"
											>
												Customer Full Name
											</Button>
											<Button
												onClick={() =>
													this.addTagToText(
														EMPLOYEE_FULL_NAME_TAG,
													)
												}
												variant="outline"
												size="sm"
											>
												Employee Full Name
											</Button>
										</div>
									</div>
									)}

									{/* Image upload */}
									{!this.state.isGroupChat && (
									<div className="space-y-2">
										<Label className="text-sm font-medium">
											Image (optional)
										</Label>
										<CustomDragAndDropUploader
											handleForm={this.handleForm}
											resetTemplateImageUrl={
												this.resetTemplateImageUrl
											}
											disabled={this.getReviewInvitationCheckboxValue()}
										/>
									</div>
									)}

									{/* Settings section */}
									<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
										{/* Review options */}
										{!this.state.isGroupChat && (
										<div className="space-y-4">
											<h3 className="text-sm font-medium">
												Review Options
											</h3>

											{/* Review Invitation */}
											<div
												className="flex items-center space-x-2 max-md:min-h-11"
												style={{
													display:
														this.props.auth.phone &&
														this.props.auth.phone.includes(
															'+61',
														)
															? 'none'
															: undefined,
												}}
											>
												<Switch
													checked={this.getReviewInvitationCheckboxValue()}
													onCheckedChange={
														this
															.updateIsReviewInvitation
													}
													id="review-invitation"
													disabled={
														this.state
															.isReviewLink ||
														this.state.formData ||
														this.state.text.includes(
															IMAGE_TAG,
														)
													}
												/>
												<Label
													htmlFor="review-invitation"
													className="text-sm"
												>
													Include review invitation
													link and image
												</Label>
											</div>

											{/* Review Link */}
											<div className="flex items-center space-x-2 max-md:min-h-11">
												<Switch
													checked={this.getReviewLinkCheckboxValue()}
													onCheckedChange={
														this.updateIsReviewLink
													}
													id="review-link"
													disabled={
														this.state
															.isReviewInvitation
													}
												/>
												<Label
													htmlFor="review-link"
													className="text-sm"
												>
													Include review link
												</Label>
											</div>

											{/* Automated Review */}
											<div className="flex items-center space-x-2 max-md:min-h-11">
												<Switch
													checked={this.getAutomatedCheckboxValue()}
													onCheckedChange={
														this.updateIsAutomated
													}
													id="automated-review"
												/>
												<Label
													htmlFor="automated-review"
													className="text-sm"
												>
													Use as automated review
													template
												</Label>
												{!this.props.auth.reseller && (
													<IconButton
														onClick={() =>
															window.open(
																'http://help.chekkit.io/en/articles/4616428-how-can-i-automatically-send-review-invitations',
																'_blank',
															)
														}
														aria-label="help"
													>
														<AlertCircleIcon className="text-slate-400 size-4" />
													</IconButton>
												)}
											</div>
										</div>
										)}

										{/* Additional settings */}
										<div className="space-y-4">
											{/* Folder */}
											<div className="space-y-2">
												<h3 className="text-sm font-medium">
													Folder
												</h3>
												{this.state.newFolderMode ? (
													<div className="space-y-2">
														<div className="flex items-center space-x-2">
															<Input
																value={
																	this.state
																		.newFolderTitle
																}
																maxLength={60}
																autoFocus
																placeholder="New folder name"
																onChange={(e) =>
																	this.setState({
																		newFolderTitle:
																			e.target
																				.value,
																	})
																}
																onKeyDown={(e) => {
																	if (
																		e.key ===
																		'Enter'
																	) {
																		e.preventDefault();
																		this.createFolderInline();
																	}
																}}
															/>
															<Button
																size="sm"
																onClick={
																	this
																		.createFolderInline
																}
															>
																Add
															</Button>
															<Button
																size="sm"
																variant="ghost"
																onClick={() =>
																	this.setState({
																		newFolderMode: false,
																		folderError:
																			'',
																	})
																}
															>
																Cancel
															</Button>
														</div>
														{this.state
															.folderError && (
															<p className="text-xs text-destructive">
																{
																	this.state
																		.folderError
																}
															</p>
														)}
													</div>
												) : (
													<Select
														onValueChange={
															this
																.handleFolderSelectChange
														}
														value={
															this.state._folder ||
															'__unfiled__'
														}
													>
														<SelectTrigger className="w-full">
															<SelectValue placeholder="No folder" />
														</SelectTrigger>
														<SelectContent>
															<SelectGroup>
																<SelectLabel>
																	Folder
																</SelectLabel>
																<SelectItem value="__unfiled__">
																	No folder
																</SelectItem>
																{(
																	this.props
																		.templateFolders ||
																	[]
																).map((folder) => (
																	<SelectItem
																		key={
																			folder._id
																		}
																		value={String(
																			folder._id,
																		)}
																	>
																		{
																			folder.title
																		}
																	</SelectItem>
																))}
																<SelectItem value="__new__">
																	+ New folder…
																</SelectItem>
															</SelectGroup>
														</SelectContent>
													</Select>
												)}
											</div>

											{/* Language */}
											<div className="space-y-2">
												<h3 className="text-sm font-medium">
													Language
												</h3>
												<div className="flex items-center space-x-2">
													<Select
														onValueChange={
															this
																.handleLanguageChange
														}
														defaultValue={
															this.state.language
														}
													>
														<SelectTrigger className="w-full">
															<SelectValue placeholder="Select language" />
														</SelectTrigger>
														<SelectContent>
															<SelectGroup>
																<SelectLabel>
																	Language
																</SelectLabel>
																<SelectItem value="English">
																	English
																</SelectItem>
																<SelectItem value="French">
																	French
																</SelectItem>
																<SelectItem value="Spanish">
																	Spanish
																</SelectItem>
															</SelectGroup>
														</SelectContent>
													</Select>
													{!this.props.auth
														.reseller && (
														<IconButton
															onClick={() =>
																window.open(
																	'http://help.chekkit.io/en/articles/4378525-changing-the-language-in-a-template',
																	'_blank',
																)
															}
															aria-label="help"
														>
															<AlertCircleIcon className="text-slate-400 size-4" />
														</IconButton>
													)}
												</div>
											</div>

											{/* Favorite */}
											<div className="space-y-2">
												<h3 className="text-sm font-medium">
													Favorite
												</h3>
												<div className="flex items-center space-x-2 max-md:min-h-11">
													<Switch
														checked={this.getFavoriteCheckboxValue()}
														onCheckedChange={
															this
																.updateIsFavorite
														}
														id="is-favorite"
													/>
													<Label
														htmlFor="is-favorite"
														className="text-sm"
													>
														Make it a favorite for
														easy access
													</Label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							{/* Preview section */}
							<div className="md:col-span-1 p-6 md:overflow-y-auto md:max-h-[70vh] bg-muted/50 max-md:p-4">
								<div className="space-y-4">
									<h3 className="text-sm font-medium">
										Preview
									</h3>
									<div className="p-4 bg-background text-foreground rounded-lg border shadow-xs">
										{this.renderMessagePreview(
											this.getText(),
										)}
									</div>
								</div>
							</div>
						</div>

						{/* Footer */}
						<div className="p-6 border-t flex items-center justify-between shrink-0 max-md:gap-2 max-md:px-4 max-md:py-3 max-md:[&_button]:h-11">
							{this.EDIT_STATE && (
								<Button
									variant="destructive"
									onClick={() => {
										this.setState({ loading: true });
										this.props
											.deleteTemplate({
												template:
													this.props.selectedTemplate,
											})
											.then(() => {
												this.closeDialog();
											})
											.catch((err) => {
												console.log(err);
												alert(
													'There was an error deleting the template. Please try again.',
												);
											})
											.finally(() => {
												this.setState({
													loading: false,
												});
											});
									}}
									disabled={this.state.loading}
									size="sm"
								>
									Delete Template
								</Button>
							)}
							{!this.EDIT_STATE && <div />}

							<div className="flex items-center space-x-2">
								<Button
									variant="outline"
									onClick={this.closeDialog}
								>
									Cancel
								</Button>
								<Button
									variant="default"
									onClick={
										this.EDIT_STATE
											? this.editTemplate
											: this.submitTemplate
									}
									disabled={!this.buttonEnabled()}
								>
									{this.EDIT_STATE ? 'Update' : 'Create'}
								</Button>
							</div>
						</div>
					</div>
				</DialogContent>
			</Dialog>
		);
	}
}

function mapStateToProps(state) {
	return { auth: state.auth, templateFolders: state.templateFolders };
}

export default connect(mapStateToProps, { addTemplateFolder })(
	CreateTemplateDialog,
);
